import AddIcon from "@mui/icons-material/Add";
import {
  useCommentEngagementMutation,
  useCommentsQuery,
  useEngagementMutation,
  useFollowTutorMutation,
} from "../service/content";
import { CommentEngagements, Engagements } from "../constants/enums";
import { showError } from "../constants/toast";
import { useRef, useState } from "react";
import SendIcon from "@mui/icons-material/Send";
import moment from "moment";
import { isValidInput } from "../utils/validations";

import { RWebShare } from "react-web-share";
import GiftModal from "../Modals/GiftModal";
import ReportContentModal from "../Modals/ReportContent";
import { useNavigate } from "react-router-dom";
import { REDIRECTLINK } from "../constants/url";

type Reply = {
  text: string;
  isReply: boolean;
  userName: string;
  id: string;
};

export const ReelsParent = ({ data }: any) => {
  const navigate=useNavigate();
  const [updateEngagement] = useEngagementMutation({});
  const [followTutor] = useFollowTutorMutation();
  const [showComments, setShowComments] = useState(false);
  const [replyHandleApi] = useCommentEngagementMutation();
  const [expandedReplies, setExpandedReplies] = useState<string[]>([]);
  const [openGift, setOpenGift] = useState<boolean>(false);
  const [openReport, setOpenReport] = useState<boolean>(false);
  const replyRef = useRef<any>(null);
  const [reply, setReply] = useState<Reply>({
    text: "",
    isReply: false,
    userName: "",
    id: "",
  });
  const { data: comments } = useCommentsQuery(
    { id: data?._id },
    { skip: !data?._id || !showComments }
  );

  const [newComment, setNewComment] = useState("");
  // const [comments, setComments] = useState<string[]>([]);

  const toggleReplies = (commentId: string) => {
    setExpandedReplies((prev) =>
      prev.includes(commentId)
        ? prev.filter((id) => id !== commentId)
        : [...prev, commentId]
    );
  };

  const followTutorFunc = async () => {
    const body = {
      tutorId: data?.user?._id || "",
    };
    try {
      const res = await followTutor(body).unwrap();
      if (res?.statusCode == 200) {
        // Optionally handle success
      }
    } catch (error: any) {
      showError(error?.data?.message || "Something went wrong");
    }
  };

  const handleEngagement = async () => {
    try {
      let body = {
        contentId: data?._id || "",
        engagementType: Engagements.LIKE,
      };
      const res = await updateEngagement(body).unwrap();
      if (res?.statusCode === 200) {
        // Optionally handle success
      }
    } catch (error: any) {
      // Optionally handle error
    }
  };

  const handleSave = async () => {
    try {
      let body = {
        contentId: data?._id || "",
        engagementType: Engagements.SAVE,
      };
      const res = await updateEngagement(body).unwrap();
      if (res?.statusCode === 200) {
        // Optionally handle success
      }
    } catch (error: any) {
      // Optionally handle error
    }
  };

  const AddComment = async () => {
    const body = {
      contentId: data?._id || "",
      engagementType: Engagements.COMMENT,
      commentText: newComment,
    };
    try {
      const res = await updateEngagement(body).unwrap();
      if (res?.statusCode == 200) {
        setNewComment("");
      }
    } catch (error: any) {
      showError(error?.data?.message || "Something went wrong");
    }
  };

  const AddCommentReply = async () => {
    const body = {
      commentId: reply.id || "",
      type: CommentEngagements.REPLY,
      reply: newComment,
    };
    try {
      const res = await replyHandleApi(body).unwrap();
      if (res?.statusCode == 200) {
        setReply({
          text: "",
          isReply: false,
          userName: "",
          id: "",
        });
        setNewComment("");
      }
    } catch (error: any) {
      showError(error?.data?.message || "Something went wrong");
    }
  };

  const LikeOnReply = async (id: string) => {
    const body = {
      commentId: id,
      type: CommentEngagements.LIKE,
    };
    try {
      const res = await replyHandleApi(body).unwrap();
      if (res?.statusCode == 200) {
      }
    } catch (error: any) {
      showError(error?.data?.message || "Something went wrong");
    }
  };
  // const handleAddComment = () => {
  //   if (newComment.trim()) {
  //     setComments([...comments, newComment.trim()]);
  //     setNewComment("");
  //   }
  // };

  return (
    <div className="reels_wp">
      <figure className="video_mn">
        <video autoPlay loop muted src={data?.images?.[0]} />
      </figure>

      {/* Video Header */}
      <div className="video_header">
        <ul>
          <li onClick={()=>navigate("/parent/posts")}>
            <span>Explore</span>
          </li>
          <li>
            <span>{data?.isFollowing ? "Following" : "Follow"}</span>
          </li>
          <li>
            <span>For You</span>
          </li>
        </ul>
        <div>
          <img src={`/static/images/search-outline.svg`} alt="search" />
        </div>
      </div>

      {/* Sidebar */}
      <div className="video_sidebar video_sidebar1" style={{ height: "480px" }}>
        <ul>
          <li className="add_profile">
            <figure onClick={followTutorFunc}>
              <img
                src={data?.user?.image || `/static/images/add_profile.jpg`}
                alt="profile"
              />
              <figcaption>{data?.user?.name?.split(" ")[0] || ""}</figcaption>
              {!data?.isFollowing && (
                <span>
                  <AddIcon />
                </span>
              )}
            </figure>
          </li>

          <li onClick={handleSave}>
            <figure>
              <img
                className={data?.isSave ? `img_white` : `img`}
                src={
                  data?.isSave
                    ? `/static/images/save.svg`
                    : `/static/images/white_save.svg`
                }
                alt="save"
              />
              <figcaption>{data?.saveCount || 0}</figcaption>
            </figure>
          </li>

          <li onClick={handleEngagement}>
            <figure>
              <img
                src={
                  data?.isLike
                    ? `/static/images/heart.png`
                    : `/static/images/likes.svg`
                }
                alt="like"
              />
              <figcaption>{data?.likeCount || 0}</figcaption>
            </figure>
          </li>

          {/* COMMENT BUTTON */}
          <li
            onClick={() => setShowComments(true)}
            className="open_comment_trigger"
          >
            <figure>
              <img src={`/static/images/white_comment.svg`} alt="comment" />
              <figcaption>{data?.commentCount || "0"}</figcaption>
            </figure>
          </li>
          <RWebShare
            data={{
              text: "Click on link to see the teaser video details",
              url: `${REDIRECTLINK}parent/Videos/${data?._id}`,
              title: data?.title || "",
            }}
          >
            <li>
              <figure>
                <img src={`/static/images/white_share.svg`} alt="share" />
                <figcaption>{data?.shareCount || 0}</figcaption>
              </figure>
            </li>
          </RWebShare>

          <li onClick={() => setOpenGift(true)}>
            <figure>
              <img src={`/static/images/white_gift.svg`} alt="gift" />
              <figcaption>Gift</figcaption>
            </figure>
          </li>
          <li onClick={() => setOpenReport(true)}>
            <figure>
              <img
                width={30}
                className="img_white"
                src={`/static/images/problem.png`}
                alt="gift"
              />
              <figcaption>Report</figcaption>
            </figure>
          </li>
        </ul>
      </div>

      {/* Footer */}
      <div className="video_footer">
        <div className="btn_grp">
          <button className="btn voilet">{data?.subjects?.name || ""}</button>
          <button className="btn primary">{data?.category?.name || ""}</button>
        </div>
        <div className="des_end">
          <h5>{data?.title || ""}</h5>
          <p dangerouslySetInnerHTML={{ __html: data?.description || "" }} />
        </div>
      </div>

      {/* COMMENT SECTION MODAL */}
      {showComments ? (
        <div className="comment_modal">
          <div className="modal_content">
            <div className="modal_header">
              <h4> {comments?.data?.total || 0} Comments</h4>
              <button onClick={() => setShowComments(false)}>✕</button>
            </div>

            <div className="comment_list comment_section">
              <ul>
                {comments?.data?.data?.length
                  ? comments?.data?.data?.map((item: any, index: number) => {
                      const isExpanded = expandedReplies.includes(item._id);
                      return (
                        <li key={index}>
                          <div>
                            <figure>
                              <img
                                src={
                                  item?.user?.image ||
                                  `/static/images/sophie.png`
                                }
                                alt="sophie"
                              />
                            </figure>
                            <div className="comment_sc_inr">
                              <h4>
                                {item?.user?.name}
                                {/* <span>Tutor</span> */}
                              </h4>
                              <p>{item?.commentText || ""}</p>
                              <div className="reaction_box">
                                <span onClick={() => LikeOnReply(item?._id)}>
                                  {item?.isLiked ? "Unlike" : "Like"}
                                </span>
                                <span
                                  onClick={() => {
                                    setReply({
                                      text: item?.commentText,
                                      isReply: true,
                                      userName: item?.user?.name,
                                      id: item?._id,
                                    });
                                    if (replyRef?.current) {
                                      console.log(replyRef, "replyRef");
                                      replyRef.current.focus();
                                    }
                                  }}
                                >
                                  Reply
                                </span>
                              </div>
                            </div>
                          </div>
                          <p className="seen_hr">
                            {moment(item?.createdAt).fromNow()}
                          </p>
                          {item?.commentReply?.length ? (
                            <p
                              className="replies"
                              onClick={() => toggleReplies(item._id)}
                            >
                              {" "}
                              {isExpanded ? "Hide replies" : "View replies"}
                            </p>
                          ) : null}
                          {isExpanded
                            ? item?.commentReply?.map((reply: any) => {
                                return (
                                  <li key={reply}>
                                    <div>
                                      <figure>
                                        <img
                                          src={
                                            reply?.replyUser?.image ||
                                            `/static/images/sophie.png`
                                          }
                                          alt="sophie"
                                        />
                                      </figure>
                                      <div className="comment_sc_inr">
                                        <h4>{reply?.replyUser?.name}</h4>
                                        <p>{reply?.reply || ""}</p>
                                      </div>
                                    </div>
                                    <p className="seen_hr">
                                      {moment(reply?.createdAt).fromNow()}
                                    </p>
                                  </li>
                                );
                              })
                            : null}
                        </li>
                      );
                    })
                  : null}
              </ul>
            </div>

            <div className="comment_input">
              <input
                ref={replyRef}
                type="text"
                placeholder={
                  reply.isReply
                    ? `reply to ${reply.userName}.. `
                    : "Add comment"
                }
                value={newComment}
                onChange={(e) => {
                  if (isValidInput(e.target.value)) {
                    setNewComment(e.target.value);
                  }
                }}
              />

              <span
                onClick={() =>
                  reply.isReply ? AddCommentReply() : AddComment()
                }
              >
                <SendIcon />
              </span>
            </div>
          </div>
        </div>
      ) : null}
      <GiftModal
        open={openGift}
        setOpen={setOpenGift}
        onClose={() => setOpenGift(false)}
        data={data}
      />
      <ReportContentModal
        open={openReport}
        setOpen={setOpenReport}
        onClose={() => setOpenReport(false)}
        data={data}
      />
    </div>
  );
};

export default ReelsParent;
